import { useContext } from 'react';
import { MercuryPagesContext } from '../context/MercuryPagesContext';

export const useMercuryPages = () => useContext(MercuryPagesContext);
